package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.workplace.AvailabilitySlotDto
import com.evoapps.evoshift.domain.model.AvailabilitySlot

class AvailabilitySlotMapper {

    fun toDomain(dto: AvailabilitySlotDto): AvailabilitySlot {
        return AvailabilitySlot(
            id = dto.id,
            label = dto.label,
            startTime = dto.startTime,
            endTime = dto.endTime
        )
    }

    fun toDto(domain: AvailabilitySlot): AvailabilitySlotDto {
        return AvailabilitySlotDto(
            id = domain.id,
            label = domain.label,
            startTime = domain.startTime,
            endTime = domain.endTime
        )
    }
}
